// Forward-compat sentinel: enums with an UNKNOWN member tolerate server values the
// schema hasn't been regenerated for yet. It is never user-selectable — see
// get-enum-options (excludes it from selectors) and use-enum-label (renders it).
export const UNKNOWN_ENUM_VALUE = 'UNKNOWN';
